const getDefaultState = () => ({
  xmlProducts: {
    2: {
      items: [],
      itemsLoading: false,
      itemsError: false,
    },
    3: {
      items: [],
      itemsLoading: false,
      itemsError: false,
    },
    4: {
      items: [],
      itemsLoading: false,
      itemsError: false,
    },
    5: {
      items: [],
      itemsLoading: false,
      itemsError: false,
    },
    6: {
      items: [],
      itemsLoading: false,
      itemsError: false,
    },
  },
  xmlChannels: {
    items: [],
    itemsLoading: false,
    itemsError: false,
  },
  countries: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  areas: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  sites: {
    items: [],
    itemsLoading: false,
    itemsError: undefined,
  },
  domains: {
    items: [],
    itemsLoading: false,
    itemsError: false,
  },
});

export default getDefaultState;



// WEBPACK FOOTER //
// ./src/store/modules/twenty/defaultState.js